// extracted by mini-css-extract-plugin
module.exports = {"number":"order-details_number__3NZdr","preloaderText":"order-details_preloaderText__1kS4g","textRow2":"order-details_textRow2__1jIpM"};